import { useState } from 'react';
import { Icon } from 'ht-styleguide';
import styles from './homehub.header.module.scss';

/* Hooks */
import useRouteController from '@scenes/HomeHub/hooks/hook.routeController';

/* Components */
import ChatPhoneModal from '@scenes/HomeHub/components/ChatPhone';
import useAnimationDirectionFlow from '@scenes/HomeHub/hooks/hook.animationFlowController';
import Maybe from '@components/Maybe';

const HomeHubHeader = () => {
  /* Local State */
  const [showModal, setShowModal] = useState(false);

  /* Hooks */
  const routeController = useRouteController();
  const { previousQuestionQuery } = useAnimationDirectionFlow();

  return (
    <div className={styles.container_header}>
      <div className={styles.icon_back_container}>
        <Maybe condition={previousQuestionQuery}>
          <Icon onClick={routeController.previousQuestionRoute} name="v2-skinny-arrow" />
        </Maybe>
      </div>
      <div>
        <Icon className={styles.icon_logo} name="logo" />
      </div>
      <div>
        <Icon onClick={() => setShowModal(true)} className={styles.icon_info} name="question" size={24} />
      </div>
      <ChatPhoneModal isVisible={showModal} hide={() => setShowModal(false)} />
    </div>
  );
};

export default HomeHubHeader;
